export enum UPLOAD_STATUS {
    CREATED = 'CREATED',
    DRAFTED = 'DRAFTED',
    FAILED = 'FAILED',
}
